import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItem } from '../../../../../core/services/menu/menu-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateService } from 'angular-ui-router';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';

interface IPageRc2006 {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    daiMultiOccurrenceOptions: IMultiOccurrenceOptions;
    daiMultiOccurrence?: IMultiOccurrence;
    valeursEcran: any;
    execRetour: IMenuItem;
    monoOccurrence?: IMonoOccurrence;
}

interface IRc2006Params {
    menuId: string;
    intcleintmag: string;
}

/* @ngInject */
export default function Rc2006Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Menu: IMenuClass,
    $state: IStateService,
    $stateParams: IRc2006Params,
    notificationHandler: INotificationHandler,
    rc0007Route: IRoute,
    rc0006Route: IRoute,
    MenuItemAction: IMenuItemActionClass,
    ecranDetails: IEcranDetailsResourcesEntite) {

    const vm: IPageRc2006 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    let execRetourEnCours = false;

    // Usage d'imputation
    vm.execRetour = new MenuItemAction(
        'LBL_BTN_RETOUR',
        'BOURET',
        () => {
            execRetourEnCours = true;

            return {
                daccleint: $state.params.daccleint,
            };
        },
        {
            iconButton: false,
            class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
            disabled: () => execRetourEnCours || !vm.daiMultiOccurrence?.dataListReady || !!vm.daiMultiOccurrence?.savingDataList || hasDaiChangementsNonSauvegardes(),
            successAction: (data: any) => {
                $state.go(getForageItem(data), {
                    id: data.doccleintnew,
                    intcleintmag: $stateParams.intcleintmag,
                    menuId: $stateParams.menuId
                });
            },
            errorAction: (error: any) => {
                notificationHandler.erreur({
                    lblTitre: 'G_LBL_ERREUR',
                    lblMessage: error.data?.message
                })
                execRetourEnCours = false;

            }
        }
    );

    vm.daiMultiOccurrenceOptions = {
        editionRapideActive: true,
        fonctions: {
            editionRapide: true,
            editionStandard: true
        },
        colonnesVisibles: [
            { nom: 'dailig', largeur: 100, changeColor: true },
            { nom: 'procod', largeur: 150, changeColor: true },
            { nom: 'prodsc', largeur: 250, changeColor: true },
            { nom: 'tydcod', largeur: 100, changeColor: true },
            { nom: 'docaffnumdoc01', largeur: 150, changeColor: true },
            { nom: 'docaffdsc01', largeur: 250, changeColor: true },
            { nom: 'refcod', largeur: 120, changeColor: true },
            { nom: 'refnom', largeur: 230, changeColor: true },
            { nom: 'rciprxuni', largeur: 126, changeColor: true }
        ],
        colonnesFixesDroite: [
            { nom: 'qtedspmov', largeur: 120, changeColor: true },
            { nom: 'qteret', largeur: 120, changeColor: true }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('qteret', { largeur: 33.33 })
        ]),
        colonnesEditionRapide: [
            { nom: 'dailig', largeur: 100, changeColor: true },
            { nom: 'procod', largeur: 150, changeColor: true },
            { nom: 'prodsc', largeur: 250, changeColor: true },
            { nom: 'tydcod', largeur: 100, changeColor: true },
            { nom: 'qtedspmov', largeur: 120, changeColor: true },
            { nom: 'qteret', largeur: 120, changeColor: true },
            { nom: 'docaffnumdoc01', largeur: 150, changeColor: true },
            { nom: 'docaffdsc01', largeur: 250, changeColor: true },
            { nom: 'refcod', largeur: 130, changeColor: true },
            { nom: 'refnom', largeur: 230, changeColor: true },
            { nom: 'rciprxuni', largeur: 126, changeColor: true }
        ], colonnesCachees: ['color']
    }

    function hasDaiChangementsNonSauvegardes(): boolean {
        if (!vm.daiMultiOccurrence?.editionRapideActive) {
            return false;
        }

        return vm.daiMultiOccurrence.dataList?.some((line: any) =>
            line?.$editionRapideCtrl?.$dirty || line?.$deleted
        ) || false;
    }

    // fonction qui retourne le forage 
    function getForageItem(data: any): string {
        if (data.tydcleint === 149) {
            return rc0006Route.NAME;
        } else {
            return rc0007Route.NAME;
        }
    }

}
